import { render, staticRenderFns } from "./comment-staker-vos-ADAs.vue?vue&type=template&id=65b31924&"
var script = {}
import style0 from "./comment-staker-vos-ADAs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports